import styled from '@emotion/styled';
import { defaultContainerSize, mq } from '../../../styles/mixins';
import { css } from '@emotion/react';
import { THEME } from '../../../common/consts/theme';

export const Section = styled.section`
  ${defaultContainerSize};
  gap: 3rem;
  position: relative;
  padding-top: 4rem;

  ${mq.large(css`
    padding-top: 5.5rem;
  `)}

  ${mq.large(css`
    padding-top: 7.5rem;
  `)}
`;

export const SectionTitle = styled.h2(
  ({ theme }) => css`
    font-size: 3rem;
    line-height: 3.5rem;
    text-align: left;
    font-weight: 400;
    letter-spacing: -0.0125rem;
    font-family: ${THEME.font.questrial};
    margin: 0 0 2rem 0;

    ${mq.large(css`
      margin-bottom: 3rem;
    `)};
  `
);

export const PositionsContainer = styled.div(
  ({ theme }) => css`
    display: grid;
    justify-content: center;
    padding-bottom: 23.063rem;
    gap: 2rem;
    grid-template-rows: repeat(4, fit-content);

    ${mq.mobileMax(css`
      padding-bottom: 12.5rem;
      justify-content: flex-start;
      grid-template-columns: repeat(2, 23rem);
      grid-template-rows: repeat(2, fit-content);
    `)}

    ${mq.xLarge(css`
      padding-bottom: 0;
      position: relative;
      grid-template-columns: repeat(2, 23rem);
      grid-template-rows: repeat(2, fit-content);
    `)}
  
    > div {
      max-width: 23rem;
      padding: 0;
    }
  `
);

export const SectionImage = styled.div`
  width: 23.063rem;
  height: 20.188rem;
  position: absolute;
  bottom: 0;
  right: 0;

  ${mq.xLarge(css`
    bottom: 50%;
    transform: translate(0%, 50%);
  `)};

  @media (min-width: 1300px) {
    transform: translate(-15%, 50%);
  }
`;
